export default __webpack_public_path__ + "static/media/status-warn.77254121.svg";